export default __webpack_public_path__ + "static/media/kapsul2.6ff57294.png";